module.exports = __webpack_public_path__ + "img/so.be5030ca.webp";